import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { SwipeableDrawer, Typography, Divider, Grid, Slide } from '@material-ui/core'
import { FilterSearch as FilterIcon, CloseCircle } from '@refera/ui-icons'
import Theme from '@refera/ui-core'
import { Button, IconButton } from '@refera/ui-web'

import { FILTERS } from './constants'
import FilterField from './filter-field'
import useStyles from './styles'

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="right" ref={ref} {...props} />
))

const ProviderFilter = ({
  handleFilterOpen,
  open,
  cityOptions,
  categoryOptions,
  onApplyFilter,
  defaultValues,
}) => {
  const styles = useStyles()

  const methods = useForm({
    shouldUnregister: false,
    defaultValues: defaultValues || {},
  })
  const { handleSubmit, reset, setValue } = methods

  React.useEffect(() => {
    if (defaultValues) {
      Object.entries(defaultValues).forEach(([key, value]) => {
        setValue(key, value)
      })
    }
  }, [defaultValues, setValue])

  const onSubmit = data => {
    onApplyFilter(data)
    handleFilterOpen()
  }

  const handleClear = () => {
    reset()
    onApplyFilter({})
    handleFilterOpen()
  }

  return (
    <SwipeableDrawer
      component="section"
      anchor="right"
      open={open}
      onClose={handleFilterOpen}
      onOpen={handleFilterOpen}
      className={styles.container}
      TransitionComponent={Transition}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid className={styles.header}>
            <Grid className={styles.headerTitle}>
              <Grid className={styles.iconWrapper}>
                <FilterIcon color={Theme.Colors.Primary.Base} />
              </Grid>
              <Typography component="h2" variant="h5" className={styles.title}>
                Filtros
              </Typography>
            </Grid>
            <IconButton onClick={handleFilterOpen} variant="ghost">
              <CloseCircle color={Theme.Colors.Primary.Base} className={styles.closeIcon} />
            </IconButton>
          </Grid>
          <Divider className={styles.divider} />
          <Grid className={styles.content}>
            {FILTERS.map(filterField => {
              if (
                filterField.name === 'tradesman_city' ||
                filterField.name === 'tradesman_work_city'
              ) {
                return <FilterField key={filterField.name} {...filterField} options={cityOptions} />
              }
              if (filterField.name === 'category') {
                return (
                  <FilterField key={filterField.name} {...filterField} options={categoryOptions} />
                )
              }
              return <FilterField key={filterField.name} {...filterField} />
            })}
          </Grid>
          <Grid className={styles.buttonsContainer}>
            <Button variant="ghost" color="primary" onClick={handleClear}>
              Limpar filtros
            </Button>
            <Button variant="primary" color="orange" type="submit">
              Aplicar filtro
            </Button>
          </Grid>
        </form>
      </FormProvider>
    </SwipeableDrawer>
  )
}

export default React.memo(ProviderFilter)
